import React, { Component } from "react";
import Button from "components/Common/Button";
import PropTypes from "prop-types";
import { Record } from "immutable";
import classNames from "classnames";
import DebouncedInput from "components/Common/DebouncedInput";

export default class PasswordResetForm extends Component {
  handleKeyDown = (event) => {
    const { resetEmail } = this.props;

    if (event.key === "Enter") {
      resetEmail();
    }
  }

  /**
 * @returns {HTMLElement}
 */
  render() {
    const {
      login, resetEmail, changeResetEmail, togglePasswordReset, isEmailValid
    } = this.props;


    return (
      <div className="g-form__block Login__block">
        <div className="Login__page-header">
          <h1>Reset Your Password</h1>
          <p>
            Forgot your password? Enter your email and we’ll send you email to reset your password.
          </p>
        </div>

        <label className="g-input__label" htmlFor="Login__reset">
          Email
        </label>
        <DebouncedInput
          customClassName={classNames(
            "Login__input g-view g-input"
          )}
          type="email"
          value={login.email}
          id="Login__reset"
          onChange={changeResetEmail}
          onKeyPress={this.handleKeyDown}
          placeholder="my@email.com"
          debounceTime={50}
          autoFocus
        />

        <div className="Login__button-container">
          <Button
            onClick={resetEmail}
            customClassName="Login__button-container__button"
            title="Send Reset Link"
            text="Send Email"
            icon="Send"
            disabled={!login.email.length || !isEmailValid}
          />
          <Button
            onClick={togglePasswordReset}
            text="Back"
            title="Back"
            customClassName="Login__button-container__back"
            light
          />
        </div>
      </div>
    );
  }
}

PasswordResetForm.propTypes = {
  resetEmail: PropTypes.func.isRequired,
  changeResetEmail: PropTypes.func.isRequired,
  togglePasswordReset: PropTypes.func.isRequired,
  login: PropTypes.instanceOf(Record).isRequired,
  isEmailValid: PropTypes.bool.isRequired
};
